export const CHEMICAL_PRODUCT_RETENTION = {
	YESSTEEL: 1,
	YESPLASTIC: 2,
	NO: 3,
}
